import React from "react";
import { GenericResponse } from "../CreateRound/CreateRoundModels";
import { QueryParams } from "../models/CouponShare";
import ItemSelect from "../Components/ItemSelect"
import { ListResponse } from "../api/ApiNgModels";
import { Sport } from "./LeagueModels";
import LeagueUtil from "./LeagueUtil";

interface ProviderSelectProps {
    value: string;
    disabled?: boolean;
    filter?: (item: string) => boolean;
    onChange: (item: string | undefined) => void;
    allItemEnabled: boolean;
    helperText?: string;
    error?: boolean;
}
const ProviderSelect: React.FC<ProviderSelectProps> = (props) => {
      
    const getProviders = async (pageSize: number, lastId?: string) : Promise<GenericResponse<ListResponse<string>>> => {
        var resp = await LeagueUtil.getProviderIds();
        return resp;
    };


    const getId = (item?: string) : string => {
        return item ? item : "";
    };

    const onChange = (item?: string) : void => {
        if (props.onChange) {
            props.onChange(item);
        }
    };
  
    return (
        <ItemSelect<string, string>
            value={props.value}
            label="Provider"
            getId={getId}
            getIdString={getId}
            getName={getId}
            getItems={getProviders}
            idFromString={s => s ? s : ""}
            onChange={onChange}
            disabled={props.disabled}
            filter={props.filter}
            getInfoText={it => ""}
            allItemEnabled={props.allItemEnabled}
            helperText={props.helperText}
            error={props.error}
    />
    );
};

export default ProviderSelect;
